<template>
  <div>
    <div v-if="error">
      <server-error :error="error" />
    </div>
    <div>
      <h2 class="mb-4">{{reportTypeName}}</h2>
      <div class="b-reports__header-info mb-6">
        <div class="row b-reports__header-row mb-2">
          <div class="col-2">
            <div class="b-reports__name mb-1">{{$t('CONTENT.contract.lessee')}}</div>
            <div class="b-reports__value">
              {{getCounterpartyName(currentContract.contract.lesseeCounterpartyId)}}
              <div class="b-contract__check mx-1" v-if="checkIsCounterpartyIntragroup(currentContract.contract.lesseeCounterpartyId)">
                <dynamic-icon class="mr-2" icon="check"></dynamic-icon>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="b-reports__name mb-1">{{$t('CONTENT.contract.lessor')}}</div>
            <div class="b-reports__value b-reports__value-wrapper">
              <span class="b-reports__value-inner" v-for="(lessor, index) in currentContract.contract.lessorCounterpartyIds">
                {{getCounterpartyName(lessor)}}
                <div class="b-contract__check ml-1" v-if="checkIsCounterpartyIntragroup(lessor)">
                <dynamic-icon icon="check"></dynamic-icon>
                </div>
                <span v-if="index !== currentContract.contract.lessorCounterpartyIds.length - 1">,&nbsp;</span>
              </span>
            </div>
          </div>
        </div>
        <div class="row b-reports__header-row">
          <div class="col-2">
            <div class="b-reports__name mb-1">{{$t('CONTENT.contract.contract_number')}}</div>
            <div class="b-reports__value">{{currentContract.contract.number}}</div>
          </div>
          <div class="col-2">
            <div class="b-reports__name mb-1">{{$t('CONTENT.reportPage.report_date')}}</div>
            <div class="b-reports__value">{{new Date() | dateFormatted}}</div>
          </div>
          <div class="col-2">
            <div class="b-reports__name mb-1">{{$tc('CONTENT.currency.currency_code', 1)}}</div>
            <div class="b-reports__value">{{currencyCode}}</div>
          </div>
        </div>
      </div>
      <div class="b-reports__header-info mb-8">
        <div class="row b-reports__header-row">
          <div class="col-4">
            <div class="b-reports__name b-reports__name_type_lg mb-1">{{$t('CONTENT.assets.rent_objects')}}</div>
          </div>
          <div class="col-3">
            <div class="b-reports__name mb-1">{{$t('CONTENT.assets.rent_period')}}</div>
          </div>
        </div>
        <div class="row b-reports__header-row" v-for="assetComponent in currentContract.assetComponents">
          <div class="col-4">
            <div class="b-reports__value mb-1">{{getAssetName(assetComponent.assetId)}}
              <span v-if="assetComponent.name">&nbsp;-&nbsp;{{assetComponent.name}}</span>
            </div>
          </div>
          <div class="col-3">
            <div class="b-reports__value mb-1">{{assetComponent.startDate | dateFormatted}} - {{assetComponent.endDate | dateFormatted}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    currentContract: {
      type: Object,
    },
    reportTypeName: {
      type: String,
    }
  },
  data() {
    return {
      error: null,
    };
  },
  computed: {
    ...mapGetters(['getContractSettings']),
    ...mapGetters(['allCounterparties']),
    ...mapGetters(['getAssets']),
    ...mapGetters(['getUnderlyingAssetTypes']),
    currencyCode() {
      return this.getContractSettings.currencyCode;
    }
  },
  methods: {
    getCounterpartyName(lesseeId) {
      for (let i = 0; i < this.allCounterparties.length; i++) {
        if(this.allCounterparties[i].idInDB === lesseeId) {
          return this.allCounterparties[i].displayName;
        }
      }
    },
    checkIsCounterpartyIntragroup(counterpartyId) {
      for (let i = 0; i < this.allCounterparties.length; i++) {
        if (this.allCounterparties[i].idInDB === counterpartyId) {
          return this.allCounterparties[i].isIntragroupTurnover;
        }
      }
    },
    getAssetName(assetId) {
      for (let i = 0; i < this.getAssets.length; i++) {
        if(this.getAssets[i].idInDB === assetId) {
          let assetType = this.getAssetType(this.getAssets[i].underlyingAssetTypeId);
          return `${assetType}. ${this.getAssets[i].name}`;
        }
      }
    },
    getAssetType(assetTypeId) {
      for (let i = 0; i < this.getUnderlyingAssetTypes.length; i++) {
        if(this.getUnderlyingAssetTypes[i].idInDb === assetTypeId) {
          return this.getUnderlyingAssetTypes[i].name;
        }
      }
    },
  }
};
</script>
